import { Group, Text } from "@mantine/core";
import {
  IconCalendarEvent,
  IconCheck,
  IconPencil,
  IconFlag,
  IconLock,
  IconTrash,
  IconUserCheck,
  IconWorld,
} from "@tabler/icons-react";
import css from "./MicChatDrawer.module.scss";

const PRIORITY_LABELS = {
  low: "Low",
  medium: "Medium",
  high: "High",
};

const RECEIPT_COPY = {
  created: {
    title: "Action created",
    icon: IconCheck,
  },
  assigned: {
    title: "Action assigned",
    icon: IconUserCheck,
  },
  updated: {
    title: "Action updated",
    icon: IconPencil,
  },
  deleted: {
    title: "Action deleted",
    icon: IconTrash,
  },
  unsent: {
    title: "Action unsent",
    icon: IconTrash,
  },
};

const formatDueDate = (dueDateIso) => {
  if (!dueDateIso) return "Tomorrow";

  const dueDate = new Date(dueDateIso);
  if (Number.isNaN(dueDate.getTime())) return dueDateIso;

  return new Intl.DateTimeFormat(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(dueDate);
};

const CreatedActionField = ({ icon: Icon, label }) => (
  <span className={css.createdActionField}>
    <Icon size={13} />
    <span>{label}</span>
  </span>
);

const ActionCreatedWidget = ({ action }) => {
  const priority = PRIORITY_LABELS[action.priority] || PRIORITY_LABELS.medium;
  const receipt = RECEIPT_COPY[action.type] || RECEIPT_COPY.created;
  const ReceiptIcon = receipt.icon;
  const assigneeLabel =
    action.assignee?.displayName || action.assignee?.email || null;

  return (
    <div className={css.createdActionReceipt}>
      <Group position="apart" align="flex-start" spacing="sm" noWrap>
        <div className={css.createdActionHeader}>
          <span className={css.createdActionIcon}>
            <ReceiptIcon size={15} />
          </span>
          <Text weight={700} size="sm" color="#253047">
            {receipt.title}
          </Text>
        </div>
      </Group>

      <Text size="sm" color="#253047" className={css.createdActionText}>
        {action.text}
      </Text>

      <div className={css.createdActionFields}>
        <CreatedActionField
          icon={IconCalendarEvent}
          label={formatDueDate(action.dueDateIso)}
        />
        <CreatedActionField icon={IconFlag} label={priority} />
        <CreatedActionField
          icon={action.private ? IconLock : IconWorld}
          label={action.private ? "Private" : "Public"}
        />
        {assigneeLabel && (
          <CreatedActionField
            icon={IconUserCheck}
            label={`To ${assigneeLabel}`}
          />
        )}
      </div>
    </div>
  );
};

export default ActionCreatedWidget;
